import React, { useEffect, useState } from 'react'
import { Button, Chip, Dialog, DialogContent, IconButton, LinearProgress } from '@mui/material'
import MoreIcon from '@mui/icons-material/MoreVert'
import PlayCircleIcon from '@mui/icons-material/PlayCircle'

const getCookie = require('../utils/getCookie')

const TaskItemDoChamado = (props) => {
    const { nome } = props;
    const { protocolo, unidade, area, classificacao, solicitante, outro,
        status, titulo, emailUsuarioSolicitante, telefoneSolicitante, setorSol,
        nomeExecutor, emailExecutor, telefoneExecutor, categoria,
        setorSolicitante, log } = props
    const send = require('../assets/clok.png')

    const [mensagem, setMensagem] = useState([])
    const [openMsg, setOpenMsg] = useState(false);




    const data = new Date(props.criacaoChamado)
    function formDate(data) {
        var day = data.getDate();
        var month = data.getMonth() + 1;
        var year = data.getFullYear();
        var dateFormatted = day + '/' + (month) + '/' + year;
        return dateFormatted
    }
    var date = formDate(data)


    const StatusButton = ({ status }) => {
        const color = statusColors[status] || "#6c757d"; // Cor padrão (cinza) se o status não estiver definido
        return (
            <button style={buttonStyle(color)}>
                {status}
            </button>
        );
    };

    const PrioridadeButton = ({ status }) => {
        const color = prioridadeColors[status] || "#6c757d"; // Cor padrão (cinza) se o status não estiver definido
        return (
          <button style={buttonStyle2(color)}>
            {"Prioridade " + status}
          </button>
        );
      };


    const statusColors = {
        Aberto: "#007bff", // Azul
        Iniciado: "#28a745", // Verde
        Parado: "#ffc107", // Amarelo
        Pendente: "#dc3545", // Vermelho
        Planejado: "#5bc0de", // Azul claro
      };


      const buttonStyle2 = (color) => ({
        backgroundColor: `${color}80`, // Cor com transparência (33 = 20% opacidade)
        color: 'black', // Texto na cor principal
        borderRadius: "12px", // Forma arredondada
        padding: "4px 10px", // Tamanho ajustado para parecer mais elegante
        fontSize: "12px", // Tamanho de fonte menor
        fontWeight: "500", // Texto semi-negrito
        display: "inline-block", // Para se comportar como uma badge
        textAlign: "center", // Centraliza o texto
        border: `1px solid ${color}77`, // Borda levemente mais escura com transparência
        marginLeft: "5px", // Margem para espaçamento
      });
    
    const buttonStyle = (color) => ({
        backgroundColor: `${color}33`, // Cor com transparência (33 = 20% opacidade)
        color: color, // Texto na cor principal
        borderRadius: "12px", // Forma arredondada
        padding: "4px 10px", // Tamanho ajustado para parecer mais elegante
        fontSize: "12px", // Tamanho de fonte menor
        fontWeight: "500", // Texto semi-negrito
        display: "inline-block", // Para se comportar como uma badge
        textAlign: "center", // Centraliza o texto
        border: `1px solid ${color}77`, // Borda levemente mais escura com transparência
        marginLeft: "5px", // Margem para espaçamento
    });

    const prioridadeColors = {
        Baixa: "#007bff", // Azul
        Media: "#28a745", // Verde
        Alta: "#dc3545", // Amarelo
        Critica: "#c60e3d", // Vermelho
        NaoDefenido: "#5bc0de", // Azul claro
      };
    










    return (
        <div style={{
            display: 'flex',
            flexDirection: 'row',
            minHeight: '100px',
            color: '#424242',
            padding: '16px',
            justifyContent: 'center',
        }}>
            <div style={{
                backgroundColor: '#ffffff',
                marginLeft: '5px',
                padding: '20px',
                flex: 1,
                borderRadius: '15px',
                boxShadow: '0px 10px 30px -10px rgba(0, 0, 0, 0.1)',
                display: 'flex',
                flexDirection: 'column',
                border: '1px solid #e0e0e0',
                transition: 'box-shadow 0.3s ease',
            }}>


                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
                    <div
                        style={{
                            flex: '1 1 calc(70% - 16px)', // Responsividade para telas menores
                            minWidth: '300px',
                            borderRight: '1px solid #ddd',
                            padding: '16px',
                            backgroundColor: '#f9f9f9',
                            borderRadius: '8px',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                        }}
                    >
                        <div
                            style={{
                                fontSize: '16px',
                                color: '#333',
                                lineHeight: '1.6',
                                wordBreak: 'break-word',
                                backgroundColor: '#fff',
                                padding: '16px',
                                borderRadius: '8px',
                                border: '1px solid #e0e0e0',
                            }}
                        >
                             <div style={{ display: "flex", gap: "8px" }}>
                        <div style={{ marginBottom: "8px" }}>
                          <StatusButton status={props.status} />
                        </div>

                        <div style={{ marginBottom: "8px" }}>
                          <PrioridadeButton status={props.classificacao} />
                        </div>
                      </div>
                            <div
                                style={{
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    marginBottom: '12px',
                                    color: '#0073e6',
                                }}
                            >
                                Assunto: {props.titulo}
                            </div>

                            {props.categoria !== '' && (
                                <div style={{ fontSize: '14px', marginBottom: '8px', color: '#555' }}>
                                    <b>Categoria:</b> {props.categoria}
                                </div>
                            )}

                            

                            

                            <hr style={{ margin: '16px 0', borderColor: '#ddd' }} />

                            <div
                                style={{
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    marginBottom: '10px',
                                    color: '#0073e6',
                                }}
                            >
                                Solicitante
                            </div>
                            <div style={{ fontSize: '14px', marginBottom: '8px', color: '#555' }}>
                                <b>Nome:</b> {props.solicitante}
                            </div>
                            <div style={{ fontSize: '14px', marginBottom: '8px', color: '#555' }}>
                                <b>Setor:</b> {props.setorSolicitante}
                            </div>
                            <div style={{ fontSize: '14px', marginBottom: '8px', color: '#555' }}>
                                <b>Email:</b> {props.emailUsuarioSolicitante}
                            </div>
                            <div style={{ fontSize: '14px', marginBottom: '8px', color: '#555' }}>
                                <b>Telefone:</b> {props.telefoneSolicitante}
                            </div>

                            <hr style={{ margin: '16px 0', borderColor: '#ddd' }} />

                            <div
                                style={{
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    marginBottom: '10px',
                                    color: '#0073e6',
                                }}
                            >
                                Unidade Responsável
                            </div>
                            <div style={{ fontSize: '14px', marginBottom: '8px', color: '#555' }}>
                                <b>Unidade:</b> {props.setorSol}
                            </div>

                            {props.nomeExecutor === '' ? (
                                <div
                                    style={{
                                        color: '#d32f2f',
                                        fontSize: '18px',
                                        marginBottom: '10px',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    Chamado aguardando responsável
                                </div>
                            ) : (
                                <>
                                    <div style={{ fontSize: '14px', marginBottom: '8px', color: '#555' }}>
                                        <b>Responsavel:</b> {props.nomeExecutor}
                                    </div>
                                    {props.outro && props.outro != props.nomeExecutor?
                                    <div style={{ fontSize: '14px', marginBottom: '8px', color: '#555' }}>
                                    <b>Responsavel:</b> {props.outro}
                                </div>
                                    
                                    :''}
                                    
                                    <div style={{ fontSize: '14px', marginBottom: '8px', color: '#555' }}>
                                        <b>Email:</b> {props.emailExecutor}
                                    </div>
                                    <div style={{ fontSize: '14px', marginBottom: '8px', color: '#555' }}>
                                        <b>Telefone:</b> {props.telefoneExecutor}
                                    </div>

                                </>
                            )}
                            <div style={{ fontSize: '14px', marginBottom: '8px', color: 'red' }}>
                                <Button

                                    size="small"
                                    onClick={() => setOpenMsg(true)}
                                    style={{

                                        color: '#fff', // Cor do texto
                                        fontSize: '10px', // Texto menor

                                        borderRadius: '8px', // Bordas arredondadas
                                        textTransform: 'none', // Manter o texto no formato original (sem letras maiúsculas)
                                        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)', // Sombra leve
                                    }}
                                >
                                    <img
                                        src={send}
                                        height={30}
                                        onClick={() => setOpenMsg(true)}
                                        style={{ cursor: 'pointer', borderRadius: '8px', transition: 'transform 0.3s ease' }}
                                        onMouseEnter={e => e.target.style.transform = 'scale(1.05)'}
                                        onMouseLeave={e => e.target.style.transform = 'scale(1)'}
                                    />
                                </Button>


                            </div>

                        </div>

                    </div>


                </div>




            </div>



            {/* <Dialog
                open={openMsg}
                style={{
                    width: '900px',
                   
                    height: 'auto',
                    overflowY: 'auto',
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    padding: '16px',
                    backgroundColor: '#fff',
                }}
            >
                <DialogContent>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            onClick={() => setOpenMsg(false)}
                            style={{
                                background: 'transparent',
                                border: 'none',
                                color: 'red',
                                cursor: 'pointer',
                                fontWeight: 'bold',
                                textDecoration: 'underline',
                            }}
                        >
                            Fechar
                        </Button>
                    </div>

                    <h2>Log do Chamado</h2>
                    <table
                        style={{
                            borderCollapse: 'collapse',
                            width: '900px',
                            backgroundColor: '#fffaf0',
                            // tableLayout: 'fixed', // Ajustar a largura da tabela
                            wordWrap: 'break-word', // Forçar quebra de linha nas células
                        }}
                    >
                        <thead>
                     
                        </thead>
                        <tbody>
                            {log
                                .filter((tarefa) => tarefa.log !== null && tarefa.log !== undefined)
                                .map((tarefa) => (
                                    <tr key={tarefa?.id || Math.random()}>
                                        
                                        <td
                                            style={{
                                               
                                                border: '1px solid #ddd',
                                                wordBreak: 'break-word', // Garantir quebra de linha
                                            }}
                                        >
                                            {tarefa?.Usuario?.nome || 'Não informado'}
                                        </td>
                                        <td
                                            style={{
                                               
                                                border: '1px solid #ddd',
                                                whiteSpace: 'pre-wrap', // Forçar quebra de linha no log
                                                wordBreak: 'break-word',
                                            }}
                                        >
                                            {tarefa?.log
                                                ? tarefa.log.replace(/<\/?[^>]+(>|$)/g, '')
                                                : 'Sem log'}
                                        </td>
                                      
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </DialogContent>
            </Dialog> */}

            <Dialog
                open={openMsg}
                style={{
                    width: '100%', // Ocupa toda a largura da tela
                    maxWidth: '900px', // Limite máximo de largura
                    height: 'auto',
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    backgroundColor: '#fff',
                }}
                PaperProps={{
                    style: {
                        maxHeight: '800px', // Limite máximo de altura
                        overflowY: 'auto', // Scroll apenas vertical
                    },
                }}
            >
                <DialogContent style={{ padding: 0 }}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px' }}>
                        <Button
                            onClick={() => setOpenMsg(false)}
                            style={{
                                background: 'transparent',
                                border: 'none',
                                color: 'red',
                                cursor: 'pointer',
                                fontWeight: 'bold',
                                textDecoration: 'underline',
                            }}
                        >
                            Fechar
                        </Button>
                    </div>

                    <h2 style={{ padding: '16px' }}>Log do Chamado</h2>
                    <div style={{ overflowX: 'hidden', padding: '16px' }}>
                        <table
                            style={{
                                borderCollapse: 'collapse',
                                width: '100%', // Tabela ocupa toda a largura disponível
                                backgroundColor: '#fffaf0',
                            }}
                        >
                            <thead>
                                <tr>
                                    {/* <th
                                        style={{
                                            padding: '12px',
                                            border: '1px solid #ddd',
                                            backgroundColor: '#f4d03f',
                                        }}
                                    >
                                        Data
                                    </th> */}
                                    {/* <th
                                        style={{
                                            padding: '12px',
                                            border: '1px solid #ddd',
                                            backgroundColor: '#f4d03f',
                                        }}
                                    >
                                        
                                    </th>
                                    <th
                                        style={{
                                            padding: '12px',
                                            border: '1px solid #ddd',
                                            backgroundColor: '#f4d03f',
                                        }}
                                    >
                                        Log
                                    </th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {log
                                    .filter((tarefa) => tarefa.log !== null && tarefa.log !== undefined)
                                    .map((tarefa) => (
                                        <tr key={tarefa?.id || Math.random()}>
                                            <td
                                                style={{
                                                    padding: '12px',
                                                    border: '1px solid #ddd',
                                                    wordBreak: 'break-word',
                                                }}
                                            >Atualizado por
                                                <b style={{ padding: '10px' }}>
                                                    {tarefa?.Usuario?.nome || 'Não informado'}
                                                </b>
                                                a
                                                <b style={{ padding: '10px', color: 'red' }}>
                                                    {Math.floor((new Date() - new Date(tarefa?.createdAt)) / (1000 * 60 * 60 * 24))}
                                                </b>
                                                dias
                                            </td>
                                            {/* <td
                                                style={{
                                                    padding: '12px',
                                                    border: '1px solid #ddd',
                                                    wordBreak: 'break-word',
                                                }}
                                            >
                                                {tarefa?.Usuario?.nome || 'Não informado'}
                                            </td> */}
                                            <td
                                                style={{
                                                    padding: '12px',
                                                    border: '1px solid #ddd',
                                                    whiteSpace: 'pre-wrap', // Forçar quebra de linha no log
                                                    wordBreak: 'break-word',
                                                }}
                                            >
                                                {tarefa?.log
                                                    ? tarefa.log.replace(/<\/?[^>]+(>|$)/g, '')
                                                    : 'Sem log'}
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </DialogContent>
            </Dialog>



        </div>





    )
}

export default TaskItemDoChamado